import { extendTheme } from '@chakra-ui/react'

const Theme = extendTheme({
  fonts: {
    heading: `Arial, Helvetica, sans-serif`,
    body: `'Raleway', sans-serif`,
  },
})

export default Theme